<template>
  <el-row>
    <el-col :span="12" :offset="6">
      <div style="font-size:20px">Location Details</div>
      <el-form
        :model="company"
        :rules="rules"
        ref="company"
        label-width="120px"
        style="margin:20px"
        label-position="left"
         :disabled="!$store.getters.isAdmin"
      >
        <el-form-item label="Location Type:">
          <el-button type="success" @click="toggleCompanyType()">{{company.type}}</el-button>
        </el-form-item>
        <el-form-item label="Name:" prop="name">
          <el-input v-model="company.name"></el-input>
        </el-form-item>
        <el-form-item label="Enabled:" prop="enabled">
          <el-switch v-model="company.isActive"/>
        </el-form-item>
        <el-form-item v-if="company.type === 'FIRMA'" label="Description:" prop="description">
          <el-input type="textarea" v-model="company.description"></el-input>
        </el-form-item>
        <el-form-item label="Address:" prop="address">
          <el-input v-model="company.address"></el-input>
        </el-form-item>
        <el-form-item label="GPS Location:" prop="location">
          <el-input v-model="company.gpsCoordinates"></el-input>
        </el-form-item>
        <el-form-item v-if="company.type === 'FIRMA'" label="Logo:" prop="logo">
          <img :src="logo">
          <el-upload v-if='$store.getters.isAdmin' class="upload-demo" drag :action="uploadUrl" :headers="uploadHeaders"
            :on-success="onUploadSucceeded" :before-upload="onBeforeUpload" :on-error="onUploadFailed">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Drop file here or
              <em>click to upload</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item v-if='$store.getters.isAdmin'>
          <el-button type="primary" @click="save()">Save</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>
import { once } from "events"
import axios from 'axios'

const uuidv4 = require("uuid/v4");


export default {
  name: "Company",
  props: ["id"],
  data() {
    return {
      company: {
        address: null,
        code: null,
        description: null,
        externalId: null,
        gpsCoordinates: null,
        isActive: true,
        logoId: "",
        name: null,
        type: null
      },
      logo: "",
      rules: {},
      uploadUrl: "",
      uploadHeaders: {},
      lastId: ""
    };
  },

  computed: {},

  created() {
    this.lastId = uuidv4().replace(/-/g, "");
    this.uploadUrl = `${process.env.VUE_APP_API}locations/logos/${this.lastId}`;

    this.uploadHeaders = {
      authorization: window.sessionStorage.getItem("token")
    };

    if (this.id !== 'add') {
      let url = `${process.env.VUE_APP_API}locations/${this.id}`;
      axios.get(url, {
        headers: {
          authorization: window.sessionStorage.getItem("token")
        }
      }).then(result => {
        this.company = result.data;
        this.logo = `${process.env.VUE_APP_API}files/logos/${this.company.logoId}`;
      }).catch(reason => {
      });
    } else {
      this.company.type = 'FIRMA';
    }
  },

  methods: {
    save() {
      this.$refs['company'].validate(valid => {
        if (valid) {
          this.saveData();
        }
      });
    },

    saveData() {
      if (this.company.externalId != null) {
        //  PATCH to update
        let url = `${process.env.VUE_APP_API}locations/${this.id}`;
        axios.put(url, this.company, {
          headers: {
            authorization: window.sessionStorage.getItem("token")
          }
        }).then(result => {
          this.$message({
            message: 'Data saved successfully',
            type: 'success'
          });
        }).catch(reason => {
          this.$message({
            message: 'Save operation failed',
            type: 'error'
          });
        });
      } else {
        let url = `${process.env.VUE_APP_API}locations`;
        axios.post(url, this.company, {
          headers: {
            authorization: window.sessionStorage.getItem("token")
          }
        }).then(result => {
          this.company.externalId = result.data.externalId;

          this.$message({
            message: 'Data saved successfully',
            type: 'success'
          });

          this.$router.replace({ name: "Company", params: { id: this.company.externalId } });
        }).catch(reason => {
          this.$message({
            message: 'Save operation failed',
            type: 'error'
          });
        });
      }
    },

    toggleCompanyType() {
      if (this.company.type === 'FIRMA')
        this.company.type = 'PARKING';
      else
        this.company.type = 'FIRMA';
    },

    onBeforeUpload(file) {
      // this.lastId = uuidv4().replace(/-/g, "");
      console.debug(`Uploading to ${this.lastId}`);
      // this.uploadUrl = `${process.env.VUE_APP_API}locations/${this.lastId}`;

      return true;
    },

    onUploadSucceeded(response, file, fileList) {
      this.logo = `${process.env.VUE_APP_API}files/logos/${this.lastId}`;
      this.company.logoId = this.lastId;

      this.lastId = uuidv4().replace(/-/g, "");
      this.uploadUrl = `${process.env.VUE_APP_API}locations/logos/${this.lastId}`;
      this.$message({
        message: 'Upload operation completed successfully',
        type: 'success'
      });
    },

    onUploadFailed(response, file, fileList) {
      this.logo = `${process.env.VUE_APP_API}files/logos/${this.lastId}`;

      this.lastId = uuidv4().replace(/-/g, "");
      this.uploadUrl = `${process.env.VUE_APP_API}locations/logos/${this.lastId}`;
      this.$message({
        message: 'Upload operation failed',
        type: 'error'
      });
    },

    onTickets() {
      this.$router.push("/tickets");
    },

    onUsers() {
      this.$router.push("/users");
    }
  }
};
</script>
